var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M8.40981 6.79917C9.14204 7.53141 9.14204 8.71859 8.40981 9.45082C7.67758 10.1831 6.49039 10.1831 5.75816 9.45082C5.02593 8.71859 5.02593 7.53141 5.75816 6.79917C6.49039 6.06694 7.67758 6.06694 8.40981 6.79917",
    stroke: "#F2EBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 15.4167V4.61758C1.66699 3.67841 2.42866 2.91675 3.36783 2.91675H16.667C17.5878 2.91675 18.3337 3.66258 18.3337 4.58341V15.4167C18.3337 16.3376 17.5878 17.0834 16.667 17.0834H3.33366C2.41283 17.0834 1.66699 16.3376 1.66699 15.4167Z",
    stroke: "#F2EBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M12.5 7.91667H15.8333",
    stroke: "#F2EBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M14.5 11.2502H12.5",
    stroke: "#F2EBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M10.0796 13.7502C9.93372 13.3843 9.70872 13.056 9.41956 12.7885V12.7885C8.93039 12.3352 8.28872 12.0835 7.62206 12.0835H6.54539C5.87872 12.0835 5.23706 12.3352 4.74789 12.7885V12.7885C4.45872 13.056 4.23372 13.3843 4.08789 13.7502",
    stroke: "#F2EBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.eb5565663a2cb7e0b332958452d193c4.svg";
export { ForwardRef as ReactComponent };